import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TRewardBenefitType } from "../../TypesNEW";
export const apiCallGetUserPromoCodeUsageData = async ({
  userId,
  limit
}: {
  userId: number;
  limit: number;
}): Promise<{
  data: {
    promocode: string;
    isUserRewarded: number;
    rewardType: TRewardBenefitType;
    rewardAmountInHours: number;
    reason: string;
    source: string;
    createdOn: string;
  }[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<
    {
      promocode: string;
      isUserRewarded: number;
      rewardType: TRewardBenefitType;
      rewardAmountInHours: number;
      reason: string;
      source: string;
      createdOn: string;
    }[]
  >(`user/getUserPromoCodeUsageData`, {
    userId,
    limit
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
